import { render } from "./BadgesHome.vue?vue&type=template&id=a1a4ad1c&scoped=true"
import script from "./BadgesHome.vue?vue&type=script&lang=js"
export * from "./BadgesHome.vue?vue&type=script&lang=js"

import "./BadgesHome.vue?vue&type=style&index=0&id=a1a4ad1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1a4ad1c"]])

export default __exports__